import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, DidYouKnow } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran14() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "14");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 14" title="Problems">
        <YouTubeEmbed videoId="AwStG0M5_UA" title="Problems — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/14-problems.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="C major — triplet feel, circle of fifths">
        {/* Jason's annotation: vi → ii7 → V7 → I (C with G/B)  |  triplet feel: every beat divided by 3 */}
        <RomanNumeralAnalysis
          label="Main progression"
          caption="Am → Dm7 → G7 → C (then G/B). Each root falls a fifth to the next."
          chords={[
            { chord: "Am",  rn: "vi",  function: "Submediant",      pitches: ["A3","C4","E4","A4"] },
            { chord: "Dm7", rn: "ii7", function: "Pre-dominant", pitches: ["D3","F3","A3","C4"] },
            { chord: "G7",  rn: "V7",  function: "Dominant",     pitches: ["G3","B3","D4","F4"] },
            { chord: "C",   rn: "I",   function: "Tonic",        pitches: ["C3","E3","G3","C4"] },
            { chord: "G/B", rn: "V⁶",  function: "Dominant",     pitches: ["B2","D3","G3","B3"] },
          ]}
        />

        <KeyIdea title="The circle-of-fifths chain">
          Jason wrote the numerals on the chart: vi, ii7, V7, I. Every root falls a perfect fifth — A → D → G → C — the vi–ii–V–I chain, a staple of jazz standards. Only G7 is a true dominant: its B rises to C and its F falls to E.
        </KeyIdea>
      </Section>

      <Section eyebrow="Takeaway" title="Triplet feel — dividing the beat by three">
        <DidYouKnow title="What triplet feel means">
          Triplet feel means every beat is divided into three equal parts instead of two. The off-beats land at 1/3 and 2/3 of each beat rather than at 1/2. Play Am–Dm7–G7–C in straight eighths, then again with triplet eighths. Same chords, same tempo — different song.
        </DidYouKnow>
      </Section>
    </LessonShell>
  );
}
